import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum OrderMasterServicesStatusIds {
  NO_SERVICES = 1,
  SOME_IN_REVIEW = 2,
  IN_REVIEW = 3,
  SOME_READY_FOR_CONTRACTS = 4,
  READY_FOR_CONTRACTS = 5,
  SOME_PREORDER = 6,
  PREORDER = 7,
  SOME_READY_FOR_SERVICEORDERS = 8,
  READY_FOR_SERVICEORDERS = 9,
  SOME_SERVICEORDERS_IN_PROGRESS = 10,
  SERVICEORDERS_IN_PROGRESS = 11,
  SOME_ACCEPTED = 12,
  ACCEPTED = 13,
  SOME_COMPLETE = 14,
  COMPLETE = 15,
  SOME_ON_HOLD = 16,
  ON_HOLD = 17,
  SOME_CANCELLED = 18,
  CANCELLED = 19,
}

export function getOrderMasterServicesStatii(): ISelectItem[] {
  return [
    {
      id: OrderMasterServicesStatusIds.NO_SERVICES,
      label: 'No Services',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_IN_REVIEW,
      label: 'Some In Review',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.IN_REVIEW,
      label: 'In Review',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_READY_FOR_CONTRACTS,
      label: 'Some Ready for Contracts',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.READY_FOR_CONTRACTS,
      label: 'Ready for Contracts',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_PREORDER,
      label: 'Some Preorder',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.PREORDER,
      label: 'Preorder',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_READY_FOR_SERVICEORDERS,
      label: 'Some Unassigned',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.READY_FOR_SERVICEORDERS,
      label: 'Unassigned',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_SERVICEORDERS_IN_PROGRESS,
      label: 'Some ServiceOrders in Progress',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SERVICEORDERS_IN_PROGRESS,
      label: 'ServiceOrders in Progress',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_ACCEPTED,
      label: 'Some Accepted',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.ACCEPTED,
      label: 'Accepted',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_COMPLETE,
      label: 'Some Complete',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.COMPLETE,
      label: 'COMPLETE',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_ON_HOLD,
      label: 'Some On Hold',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.ON_HOLD,
      label: 'On Hold',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.SOME_CANCELLED,
      label: 'Some Cancelled',
      disabled: true,
    },
    {
      id: OrderMasterServicesStatusIds.CANCELLED,
      label: 'Cancelled',
      disabled: true,
    },
  ]
}

export const getOrderMasterServiceStatusByLabel = getItemByLabelFactory(
  getOrderMasterServicesStatii
)
export const getOrderMasterServiceStatusById = getItemByIdFactory(
  getOrderMasterServicesStatii
)
